import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
export const ContentPreview = ({ uploadedFile }) => {
    const { t } = useTranslation();
    const isImage = uploadedFile.file.type.startsWith('image/') ||
        /\.(jpg|jpeg|png)(\?|$)/i.test(uploadedFile.preview);
    const isPdf = uploadedFile.file.type === 'application/pdf' || /\.pdf(\?|$)/i.test(uploadedFile.preview);
    if (isImage) {
        return (_jsx("img", { src: uploadedFile.preview, alt: uploadedFile.file.name, className: styles.thumbnailImage, onClick: (e) => {
                e.stopPropagation();
                window.open(uploadedFile.preview, '_blank');
            }, onError: (e) => {
                const target = e.target;
                target.style.display = 'none';
                target.parentElement.innerHTML = '<div class="img-fallback"><span>IMG</span></div>';
            } }));
    }
    if (isPdf) {
        const baseUrl = uploadedFile.preview;
        const sep = baseUrl.includes('#') ? '&' : '#';
        const pdfPreviewUrl = `${baseUrl}${sep}toolbar=0&navpanes=0&scrollbar=0&view=FitH&page=1`;
        return (_jsxs("div", Object.assign({ className: styles.embedPdfWrapper }, { children: [_jsx("embed", { src: pdfPreviewUrl, type: "application/pdf", className: styles.embedPdf }), _jsx("div", { onClick: (e) => {
                        e.stopPropagation();
                        window.open(baseUrl, '_blank');
                    }, className: styles.embedPdfOpen, title: t('label.upload_test.pdf'), role: "button", "aria-label": "Open PDF" })] })));
    }
    return (_jsx("div", Object.assign({ className: styles.pdfIcon }, { children: _jsx("span", { children: t('label.upload_test.pdf') }) })));
};
